import React, { Component } from 'react';
import { faRefresh, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export class ItemOptionsFilter extends Component {

    constructor(props) {
        super(props);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown.bind(this));
        document.getElementById("first-filter").focus();
    }

    //Remove listener when component unmounts
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown.bind(this));
    }

    //Clear filters and focus on first filter box when Ctrl + F is pressed
    handleKeyDown(event) {
        //prevent default for Ctrl + F, but only that combination
        if (event.ctrlKey && event.keyCode === 70) {
            event.preventDefault();
            document.getElementById("first-filter").focus();
            this.props.resetFilters();
        }
    }

    render() {
        var itemFilters = this.props.itemFilters;
        var updateFilterObjectFunction = this.props.updateFilterObject;
        var filtersArray = Object.values(itemFilters);
        var firstBox = filtersArray[0].name;
        var hideClass = "imageIcon show-hide-complete " + (this.props.hideCompletes ? "hide-completes" : "");
        return (
            <div className="item-options-filter">

                    {
                        filtersArray.map(function (filter, idx) {
                            return (
                                <label>
                                    <p>{filter.name}</p>
                                    <input className="filter-input" id={filter.name == firstBox ? "first-filter" : ""} value={filter.value} onChange={(e) => { updateFilterObjectFunction(e, filter.key) }} type="text" autocomplete="off" />
                                </label>
                            );
                        })
                }
                <FontAwesomeIcon className={hideClass} onClick={this.props.showHideCompletes} size="lg" icon={faEyeSlash} title="Hide items that are complete" />
                <FontAwesomeIcon className="imageIcon refresh-filters" onClick={this.props.resetFilters} size="lg" icon={faRefresh} title="Keyboard Shortcut: Ctrl + F" />
                </div>
        );
    }
}